<template>
    <v-container>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css" integrity="sha256-h20CPZ0QyXlBuAw7A+KluUYx/3pK+c7lYEpqLTlxjYQ=" crossorigin="anonymous" />
        <v-row class="text-center">
            <v-col cols="12">
                <h1 class="display-2 font-weight-bold mb-3">
                    Obrigado pelo Cadastro
                </h1>                
                <p class="subheading font-weight-regular">
                  <span v-if="newCad == 'true'">
                <br>O Código de acesso dos Papais é: <b>{{this.babyData.URL}}</b><br>
                A Chave de acesso dos Papais é: <b>{{this.babyData.chaveDeAcesso}}</b><br></span>
                <br>O Link para o seu Chá de Bebê é o seguinte:<br>
                
                    <a :href="'//'+url" target="_blank" >{{this.url}}</a>

                <br><br>
                Compartilhe em suas Redes Sociais
                <br>
                </p> 
                <div class="share-network-list">
                    <ShareNetwork
                        v-for="network in networks"
                        :network="network.network"
                        :key="network.network"
                        :style="{backgroundColor: network.color}"
                        :url="sharing.url"
                        :title="sharing.title"
                        :description="sharing.description"
                        :quote="sharing.quote"
                        :hashtags="sharing.hashtags"
                        :twitterUser="sharing.twitterUser"
                    >
                        <v-icon dark>{{network.icon}}</v-icon>
                        <span>{{ network.name }}</span>                        
                    </ShareNetwork> 
                </div>             
               
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { db } from '@/main'

export default {
    data: () => ({
        url: '',
        shortUrl: '',
        babyData: '',
        newCad: false,
        //Verificar
        sharing: {
            url: '',
            title: 'Venha participar conosco desse momento tão especial, acesse o link abaixo do Chá Revelação: ',
            description: 'This week, I’d like to introduce you to "Vite", which means "Fast". It’s a brand new development setup created by Evan You.',
            quote: 'The hot reload is so fast it\'s near instant. - Evan You',
            hashtags: 'charevelação, bebe, gravida, convite',
            twitterUser: 'youyuxi'
        },
        networks: [
            { network: 'facebook', name: 'Facebook', icon: 'fab fah fa-lg fa-facebook-f', color: '#1877f2' },
            { network: 'whatsapp', name: 'Whatsapp', icon: 'fab fah fa-lg fa-whatsapp', color: '#25d366' },
            { network: 'twitter', name: 'Twitter', icon: 'fab fah fa-lg fa-twitter', color: '#1da1f2' },
            { network: 'telegram', name: 'Telegram', icon: 'fab fah fa-lg fa-telegram-plane', color: '#0088cc' },            
            { network: 'email', name: 'Email', icon: 'far fah fa-lg fa-envelope', color: '#333333' },
            { network: 'skype', name: 'Skype', icon: 'fab fah fa-lg fa-skype', color: '#00aff0' },
            { network: 'sms', name: 'SMS', icon: 'far fah fa-lg fa-comment-dots', color: '#333333' },
        ]        
    }),
    async created(){
        this.url = "www.revelacha.com.br/access/" + this.$route.params.pathURL
        this.sharing.url = this.url        
        this.newCad = sessionStorage.getItem("newCad");
        // console.log("Session", this.newCad)
        await setTimeout(()=>{}, 5000);

        this.shortUrl = this.$route.params.pathURL;
        await db.collection('revelacoes').where('URL','==',this.shortUrl).get()
        .then((seg) => {    
            this.babyData = seg.docs.map(doc => {let a = doc.data(); a.id = doc.id; return a})[0];
            let nomeMano = this.babyData.nomeMenino
            let nomeMina = this.babyData.nomeMenina
            
            // console.log("nome",nomeMano.indexOf(" "))
            this.babyData.FirstNameMenino =  nomeMano.substring(0, (nomeMano.indexOf(" ") >= 0)? nomeMano.indexOf(" ") : nomeMano.length)
            this.babyData.FirstNameMenina =  nomeMina.substring(0, (nomeMina.indexOf(" ") >= 0)? nomeMina.indexOf(" ") : nomeMina.length)             

            let revelationTime = this.formatDate(this.babyData.dataRevelacao)
            
            this.sharing.quote =  'Sonhamos e esperamos com esse dia, e então chegou a hora de sabermos se é a ' + this.babyData.FirstNameMenina + ' ou o ' + this.babyData.FirstNameMenino + ' que está a caminho. Convido vocês a participarem mesmo que virtualmente do nosso Chá Revelação, no dia '+ revelationTime.data + ' às ' + revelationTime.time + '. Vamos descobrir juntos?'            
            this.sharing.description = 'Sonhamos e esperamos com esse dia, e então chegou a hora de sabermos se é a ' + this.babyData.FirstNameMenina + ' ou o ' + this.babyData.FirstNameMenino + ' que está a caminho. Convido vocês a participarem mesmo que virtualmente do nosso Chá Revelação, no dia '+ revelationTime.data + ' às ' + revelationTime.time + '. Vamos descobrir juntos?'
            // console.log(this.shortUrl,this.babyData)           
        }).catch(function (error) {
            console.error("Error get userss: ", error);
        });         
    },
    methods: {
      formatDate(time){
        let data = new Date(time)
        let retorno = {
          'data': '',
          'time': ''
        }
        let month = data.getMonth() + 1
        retorno.data = ('0' + data.getDate()).slice(-2) + '/'
            + ('0' + (month)).slice(-2) + '/'
            + data.getFullYear()

        retorno.time = data.getHours() + ':' + data.getMinutes()
        return retorno 
      },          
    }
}
</script>

<style>
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }
  h1 {
    text-align: center;
    margin: 50px 0 80px;
  }
  .share-network-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1000px;
    margin: auto;
  }
  a[class^="share-network-"] {
    flex: none;
    color: #FFFFFF !important;
    background-color: #333;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 10px 10px 0;
  }
  a[class^="share-network-"] .fah {
    background-color: rgba(0, 0, 0, 0.2);
    padding: 10px;
    flex: 0 1 auto;
  }
  a[class^="share-network-"] span {
    padding: 0 10px;
    flex: 1 1 0%;
    font-weight: 500;
  }
</style>